import React, { useRef } from "react";
import {
  Row,
  Col,
  Card,
  Modal,
  Avatar,
  Spin,
  TimePicker,
  Tabs,
  Table,
  message,
  Button,
  Badge,
  Slider,
} from "antd";
import { useState, useEffect } from "react";
import COLORS from "common/Colors";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  getUserInfo,
  getNotificationList,
  getUserRoleId,
  getProfilePic,
  getClientid,
  getMenuList,
  getUserList,
} from "redux/selectors";
import { get, startCase } from "lodash";
import { DEVICE } from "common/Device";
import ChangePasswordModal from "organisms/ChangePasswordModal";
import { bindActionCreators } from "redux";
import {
  clearStore,
  setIsUserLoggedIn,
  setProfilePic,
  setUserList,
} from "redux/actions";
import { Switch, Input } from "antd";
import { CALL_API } from "common/API";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Icon from "atoms/Icon";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import ViewMore from "organisms/ViewMore";
import EditProfile from "organisms/EditProfile";
import download from "downloadjs";
import { STATUS_CODE } from "common/Constants";
import { SearchOutlined } from "@ant-design/icons";
import Details from "./HRPolicy/Details";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useTranslation } from "react-i18next";
import MainStyledDropzone from "./Dropzone";
import AvatarEditor from "react-avatar-editor";

const StyledModal = styled(Modal)`
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-header {
    border-bottom: none !important;
    border-radius: 40px 40px 0 0;
  }
  .ant-modal-footer {
    border-top: none !important;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .modal {
    display: flex;
    justify-content: center;
    border-radius: 10px;
  }
  .ant-modal-body > div:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .editor_div {
    width: 75%;
  }
`;

const StyledTable = styled(Table)`
  padding: 0;
  margin-bottom: 0;
  table {
    table-layout: auto !important;
  }
  .ant-table-wrapper {
    margin-bottom: 0;
    border: 2px solid red !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #e2e2e8;

    border-radius: 8px;
  }
  .ant-table-cell {
    height: 50px;
  }
  .ant-table-thead .ant-table-cell {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    white-space: normal;
  }
`;

const StyledProfileContainer = styled.div`
  .right {
    display: flex;
    justify-content: end;
    gap: 20px;
    width: 100%;
    background: #e6e6e6;
    padding: 15px;
    border-radius: 5px;
    @media (max-width: 376px) {
      flex-direction: column;
      font-size: 12px;
    }
  }
  @media ${DEVICE.tablet} {
    .second_half_info {
      margin-top: 15px;
    }
  }
`;

const StyledStaffNameContainer = styled.div`
  text-align: center;
  .staff-name {
    font-weight: bold;
    font-size: 1rem;
    padding-top: 10px;
  }
  .location {
    padding-top: 5px;
    svg {
      vertical-align: sub;
      margin-right: 5px;
    }
  }
`;

const StyledAvatar = styled(Avatar)`
  font-size: 3rem;
  height: 100px;
  width: 100px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
  .ant-avatar-string {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: center;
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }
  @media screen and (max-width: 430px) {
    padding-left: 8%;
  }
`;

const StyledDocumentModal = styled(Modal)`
  height: 100vh;
  max-width: 80rem;
  padding: 1%;
  width: 100%;
  .ant-modal-content {
    height: 100vh;
    width: 100%;
    box-shadow: none;
  }
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    max-height: 80rem;
    transform: scale(0.85);
  }
  .iframe {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    transform: scale(0.85);
  }
  .file_fit {
    width: 100%;
    height: 100%;
  }
  .img_fit {
    max-width: 80vw;
    max-height: 100vh;
  }
`;

const StyledCard = styled(Card)`
  margin-bottom: 20px;
  .main_row {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (max-width: 912px) {
    .second_half_info {
      margin-top: -25px;
    }
  }
`;

const StyledCard1 = styled(Card)`
  width: 100%;
  height: 100%;
  padding: 10px;
  .main_div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    .mb-2 {
      font-size: 18px;
      padding-left: 0px !important;
    }
  }
  @media (max-width: 426px) {
    padding: 0px;
    .main_div {
      gap: 20px;
    }
  }
`;

const StyleRow = styled(Row)`
  .sub_title {
    font-weight: bold;
  }
  @media (max-width: 426px) {
    font-size: 10px;
    .row-gap {
      padding-bottom: 10px;
    }
    .ant-picker-input > input {
      font-size: 10px;
    }
  }
`;

const StyledTab = styled.div`
  .ant-tabs-nav {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    /* padding-right: 20px; */
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
    position: absolute;
    bottom: -1px !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }
  .ant-tabs-nav-list {
    border-bottom: 2px solid #80808033;
  }

  @media (min-width: 320px) and (max-width: 420px) {
    .ant-tabs-tab {
      margin: 0 !important;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      gap: 1rem;
    }
  }
  .personal_details_box {
    padding: 10px;
    box-shadow: 0px 3px 6px #00000015;
  }
  .border-style {
    border-bottom: 1px solid #f2f2f2;
    border-width: 90%;
  }
`;

const ResetPasswordLink = styled.div`
  cursor: pointer;
  color: #2d53da;
  font-weight: bold;
  .ant-btn {
    border: 1px solid rgb(45, 83, 218) !important;
    color: #2d53da !important;
  }
`;

function MyProfile({
  userInfo,
  userRoleId,
  profilePic,
  ClientId,
  menuList,
  userList,
  setUserLoggedIn,
  updateUserList,
  saveProfilePic,
}) {
  const { t } = useTranslation();

  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const filteruser = userList?.filter(
    (item) => item?.userid === get(userInfo, "userid", "")
  );

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const filtermenulist = Menulist?.filter((item) => item?.key === "profile");

  let tabMenus = filtermenulist[0]?.subMenu?.filter(
    (item) => item?.key === "mydetails" || item?.key === "reportpreference"
  );
  let newArray = [];
  if (tabMenus) {
    newArray?.push(...tabMenus);
  }

  const items =
    newArray &&
    newArray
      ?.filter((data) => data?.access === true)
      .map((data, index) => ({
        id: index,
        label: data?.title,
        component: <></>,
      }));

  function generateUniqueId() {
    const usedIds = [];
    let uniqueId = "";
    while (uniqueId.length !== 6) {
      const randomNumber = Math.floor(Math.random() * 900000) + 100000;
      if (!usedIds.includes(randomNumber.toString())) {
        usedIds.push(randomNumber.toString());
        uniqueId += randomNumber.toString();
      }
    }
    return uniqueId;
  }

  const [uniqueId, setUniqueId] = useState(generateUniqueId());

  let userId = userInfo?.userid;
  let splitUserId = userId.split("@");
  let userIdWithoutDomain = splitUserId[0];
  let updatedUserId = userIdWithoutDomain + uniqueId;

  const [attendanceReport, setAttendanceReport] = useState(false);
  const [overtimeReport, setOvertimeReport] = useState(false);
  const [earlyCheckoutReport, setEarlyCheckoutReport] = useState(false);
  const [lateCheckinReport, setLateCheckinReport] = useState(false);
  const [absentReport, setAbsentReport] = useState(false);
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [attendanceReportId, setAttendanceReportId] = useState(0);
  const [overtimeReportId, setOvertimeReportId] = useState(0);
  const [earlyCheckoutReportId, setEarlyCheckoutReportId] = useState(0);
  const [lateCheckinReportId, setLateCheckinReportId] = useState(0);
  const [absentReportId, setAbsentReportId] = useState(0);
  const [attendanceReportTime, setAttendanceReportTime] = useState();
  const [overtimeReportTime, setOvertimeReportTime] = useState();
  const [earlyCheckoutReportTime, setEarlyCheckoutReportTime] = useState();
  const [lateCheckinReportTime, setLateCheckinReportTime] = useState();
  const [absentReportTime, setAbsentReportTime] = useState();
  const [activeTab, setActiveTab] = useState(items ? items[0]?.label : "");
  const [zoomin, setZoomin] = useState(1);
  const [rotatein, setRotatein] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const [updateState, setUpdateState] = useState("");
  const [EmployeeDetails, setEmployeeDetails] = useState({});
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [previewType, setPrreviewType] = useState("");
  const [previewURL, setPreviewURL] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [showComponent, setShowComponent] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      { fetch_master_data }
    );
    if (code === STATUS_CODE.SUCCESS) {
      updateUserList(userList);
      let profileUpdate = userList?.filter(
        (val) => val?.userid === userInfo.userid
      );
      if (profileUpdate?.length !== 0) {
        saveProfilePic(profileUpdate[0]?.profileurl);
      }
    }
  };

  const handleUploadProfile = async () => {
    let x = await settingNewCropImage();
    try {
      setUniqueId(generateUniqueId());
      const obj = {
        userid: updatedUserId,
        filetype: selectedImage.type,
        content: x,
        filename: uniqueId,
        emailid: userInfo?.userid,
      };
      setConfirmLoading(true);
      const { code } = await CALL_API(
        `profile-upload/${ClientId}`,
        "post",
        obj
      );
      if (code === "SUCCESS") {
        setShowImageModal(false);
        fetchMasterData();
        setConfirmLoading(false);
      }
      setConfirmLoading(false);
    } catch (error) {
      console.error("[handleUploadProfile] Error -->", error);
      setConfirmLoading(false);
    }
  };

  const editorRef = useRef(null);
  const settingNewCropImage = async () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImage();
      const croppedImage = canvas.toDataURL();
      return croppedImage;
    }
  };

  const objectUrl = React.useMemo(
    () => (selectedImage ? URL.createObjectURL(selectedImage) : null),
    [selectedImage]
  );

  const goBack = () => {
    setIsEdit(false);
    setShowComponent(1);
  };

  const logoutbtnstyle = { borderColor: "#000", color: "#000" };
  let history = useHistory();

  const handleTabSelect = (key) => {
    const activeTab = items.find((item) => item.id === key);
    if (activeTab) setActiveTab(activeTab.label);
  };

  const activeTabId = items.find((item) => item.label === activeTab)?.id;

  const logoutUser = () => {
    Modal.confirm({
      icon: "",
      content: t("Are you sure you want to logout?"),
      okText: t("Logout"),
      cancelText: t("Cancel"),
      cancelButtonProps: {
        style: { borderColor: "#2D53DA", color: "#2D53DA" },
      },
      onOk: () => {
        setTimeout(() => {
          window.localStorage.removeItem("token");
          window.location.href = "https://www.foresyts.ai/";
        }, 500);
      },
    });
  };

  const getPreferenceData = async () => {
    toggleReportLoader(true);
    if (ClientId) {
      const response = await CALL_API(`user-preference/${ClientId}`, "get");
      response.map((val) => {
        if (val?.reportId === 1) {
          setAttendanceReport(val?.statusName === "true" ? true : false);
          setAttendanceReportId(val?.userPreferenceId);
          setAttendanceReportTime(moment(val?.userPreferenceTime, "HH:mm"));
        } else if (val?.reportId === 2) {
          setOvertimeReport(val?.statusName === "true" ? true : false);
          setOvertimeReportId(val?.userPreferenceId);
          setOvertimeReportTime(moment(val?.userPreferenceTime, "HH:mm"));
        } else if (val?.reportId === 3) {
          setLateCheckinReport(val?.statusName === "true" ? true : false);
          setLateCheckinReportId(val?.userPreferenceId);
          setLateCheckinReportTime(moment(val?.userPreferenceTime, "HH:mm"));
        } else if (val?.reportId === 4) {
          setEarlyCheckoutReport(val?.statusName === "true" ? true : false);
          setEarlyCheckoutReportId(val?.userPreferenceId);
          setEarlyCheckoutReportTime(moment(val?.userPreferenceTime, "HH:mm"));
        } else if (val?.reportId === 5) {
          setAbsentReport(val?.statusName === "true" ? true : false);
          setAbsentReportId(val?.userPreferenceId);
          setAbsentReportTime(moment(val?.userPreferenceTime, "HH:mm"));
        }
      });
      toggleReportLoader(false);
    }
  };

  const handleChange = async (id, val, time) => {
    CALL_API(`user-preference/${ClientId}/${id}`, "patch", {
      status_name: val,
      user_preference_time: time,
    });
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    await delay(2000);
    getPreferenceData();
  };

  const paginationOptions = {
    showTotal: (total, range) =>
      `${range[0]}-${range[1]} ${t("of")} ${total} ${t("items")}`,
    pageSize: 20,
    showSizeChanger: false,
  };

  useEffect(() => {
    setEmployeeDetails({
      userid: filteruser[0]?.userid || "",
      startdate: filteruser[0]?.startdate || "",
      dateofbirth: filteruser[0]?.dateofbirth || "",
      enddate: filteruser[0]?.enddate || "",
      bandname: filteruser[0]?.bandname || "",
      bandid: filteruser[0]?.bandid || "",
      overtimestatus: filteruser[0]?.overtimestatus || "",
      salary: filteruser[0]?.salary || "",
      profileurl: filteruser[0]?.profileurl || null,
      gender: filteruser[0]?.gender || "",
      age: filteruser[0]?.age || "",
      maritalstatus: filteruser[0]?.maritalstatus || "",
      nationality: filteruser[0]?.nationality || "",
      roleid: filteruser[0]?.roleid || "",
      address: filteruser[0]?.presentaddress || "",
      phoneno: filteruser[0]?.phoneno || "",
      institutename: filteruser[0]?.institutename || "",
      jobtitle: filteruser[0]?.jobtitle || "",
      professionalsince: filteruser[0]?.professionalsince || "",
      hireddate: filteruser[0]?.hireddate || "",
      relevant: filteruser[0]?.relevant || "",
      national_id: filteruser[0]?.national_id || "",
      nssf: filteruser[0]?.nssf || "",
      krapin: filteruser[0]?.krapin || "",
      sharegnum: filteruser[0]?.sharegnum || "",
      driverslicense: filteruser[0]?.driverslicense || "",
      contract: filteruser[0]?.contract || "",
      employeesponser: filteruser[0]?.employeesponser || "",
      statusname: filteruser[0]?.statusname || "",
      jobdescription: filteruser[0]?.jobdescription || "",
      emergencycontactname: filteruser[0]?.emergencycontactname || "",
      emergencycontactnumber: filteruser[0]?.emergencycontactnumber || "",
      statusid: filteruser[0]?.statusid || "",
      employementtype: filteruser[0]?.employementtype || "",
      baselocationid: filteruser[0]?.baselocationid || "",
      basedepartmentid: filteruser[0]?.basedepartmentid || "",
      employeeid: filteruser[0]?.employeeid || "",
      initial: filteruser[0]?.initial || "",
      firstname: filteruser[0]?.firstname || "",
      lastname: filteruser[0]?.lastname || "",
      salutation: filteruser[0]?.salutation || "",
      professionalcertification: filteruser[0]?.professionalcertification
        ? filteruser[0]?.professionalcertification
        : [],
      lastpromotionlevel: filteruser[0]?.lastpromotionlevel || "",
      companyname: filteruser[0]?.companyname || "",
      educationdetails: filteruser[0]?.educationdetails || [],
      workexperience: filteruser[0]?.workexperience || [],
      professionalcertifications: filteruser[0]?.professionalcertifications
        ? filteruser[0]?.professionalcertifications
        : [],
      practicaltrainings: filteruser[0]?.practicaltrainings || [],
      lastpromotiondate: filteruser[0]?.lastpromotiondate || "",
      probationstartdate: filteruser[0]?.probationstartdate || "",
      probationenddate: filteruser[0]?.probationenddate || "",
      contractstartdate: filteruser[0]?.contractstartdate || "",
      contractenddate: filteruser[0]?.contractenddate || "",
      reportingmanager: filteruser[0]?.reportingmanager || "",
      interimexitby: filteruser[0]?.interimexitby || "",
      interimexiton: filteruser[0]?.interimexiton || "",
    });
  }, [userList]);

  useEffect(() => {
    getPreferenceData();
  }, [userRoleId]);

  const personalDet = [
    { data: t("Salutation"), value: filteruser[0]?.salutation || "-" },
    { data: t("Initial"), value: filteruser[0]?.initial || "-" },
    { data: t("First Name"), value: filteruser[0]?.firstname || "-" },
    { data: t("Last Name"), value: filteruser[0]?.lastname || "-" },
    { data: t("Employee ID"), value: filteruser[0]?.employeeid || "-" },
    { data: t("Email ID"), value: filteruser[0]?.userid || "-" },
    { data: t("Phone No"), value: filteruser[0]?.phoneno || "-" },
    {
      data: t("Date Of Birth"),
      value: filteruser[0]?.dateofbirth
        ? moment(filteruser[0]?.dateofbirth).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: t("Marital Status"),
      value: filteruser[0]?.maritalstatus
        ? filteruser[0]?.maritalstatus.charAt(0).toUpperCase() +
          filteruser[0]?.maritalstatus.slice(1)
        : "-",
    },
    { data: t("Age"), value: filteruser[0]?.age || "-" },
    {
      data: t("Gender"),
      value: filteruser[0]?.gender
        ? filteruser[0]?.gender.charAt(0).toUpperCase() +
          filteruser[0]?.gender.slice(1)
        : "-",
    },
    {
      data: t("Country"),
      value: filteruser[0]?.nationality
        ? filteruser[0]?.nationality.charAt(0).toUpperCase() +
          filteruser[0]?.nationality.slice(1)
        : "-",
    },
    { data: t("Address"), value: filteruser[0]?.presentaddress || "-" },
    {
      data: t("Emergency Contact Name"),
      value: filteruser[0]?.emergencycontactname || "-",
    },
    {
      data: t("Emergency Contact Number"),
      value: filteruser[0]?.emergencycontactnumber || "-",
    },
  ];

  const WorkInfoDetails = [
    {
      data: t("Overtime Eligible"),
      value: filteruser[0]?.overtimestatus || "-",
    },
    { data: t("Company Name"), value: filteruser[0]?.companyname || "-" },
    {
      data: t("Last Promotion Date"),
      value: filteruser[0]?.lastpromotionlevel
        ? moment(filteruser[0]?.lastpromotionlevel).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: t("Professional Since"),
      value: filteruser[0]?.professionalsince
        ? moment(filteruser[0]?.professionalsince).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: t("Last Promotion Level"),
      value: filteruser[0]?.lastpromotion ? filteruser[0]?.lastpromotion : "-",
    },
    { data: t("Job Title"), value: filteruser[0]?.jobtitle || "-" },
    {
      data: t("Hired Date"),
      value: filteruser[0]?.hireddate
        ? moment(filteruser[0]?.hireddate).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: t("Employee Sponsor"),
      value: filteruser[0]?.employeesponser || "-",
    },
    {
      data: t("Status"),
      value:
        filteruser[0]?.statusid === "1" ? t("Active") : t("In Active") || "-",
    },
  ];

  const EducationColumns = [
    {
      title: t("Institute Name"),
      dataIndex: "institutename",
      key: "institutename",
      width: "5%",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate, record) => {
        if (fromdate && record?.institutename && moment(fromdate).isValid()) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate, record) => {
        if (todate && record?.institutename && moment(todate).isValid()) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Exam Body"),
      dataIndex: "exambody",
      key: "exambody",
      align: "center",
      width: "5%",
    },
    {
      title: t("Awarded"),
      dataIndex: "awarded",
      key: "awarded",
      align: "center",
      width: "5%",
    },
    {
      title: t("Attachment"),
      dataIndex: "attachment",
      key: "attachment",
      align: "center",
      width: "5%",
      render: (attachment, record) => {
        if (attachment[0]?.name !== "-") {
          return (
            <button
              className="bg-transparent text-primary border-0"
              onClick={() => {
                setPrreviewType(attachment[0]?.name?.split(".")?.pop());
                handlePreviewClick(
                  record?.attachment[0]?.documentId,
                  "educationdetails",
                  attachment[0]?.name
                );
              }}
            >
              {attachment[0]?.name}
            </button>
          );
        } else {
          return "-";
        }
      },
    },
  ];

  const handlePreviewClick = async (id, type, document) => {
    const preview = document?.split(".")?.pop();
    toggleLoadingDocuments(true);
    const { code, url } = await CALL_API(`document-list/${ClientId}`, "post", {
      method: "preview-user-document",
      documentId: id,
      identityName: type,
      userId: filteruser?.userid,
    });
    if (code === STATUS_CODE.SUCCESS) {
      if (
        preview === "jpg" ||
        preview === "png" ||
        preview === "jpeg" ||
        preview === "svg" ||
        preview === "pdf"
      ) {
        setIsPreviewModalOpen(true);
        setPreviewURL(url);
      } else {
        download(url);
      }
    } else {
      message.error(t("Something went wrong!! Please try again."));
    }
    toggleLoadingDocuments(false);
  };

  const PersenalcertificationColumns = [
    {
      title: t("Certification Type"),
      dataIndex: "certificationtype",
      key: "certificationtype",
      width: "5%",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate, record) => {
        if (
          fromdate &&
          record?.certificationtype &&
          moment(fromdate).isValid()
        ) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate, record) => {
        if (todate && record?.certificationtype && moment(todate).isValid()) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Remarks"),
      dataIndex: "remarks",
      key: "remarks",
      align: "center",
      width: "5%",
    },
    {
      title: t("Attachment"),
      dataIndex: "attachment",
      key: "attachment",
      width: "5%",
      render: (attachment, record) => {
        if (attachment[0]?.name !== "-") {
          return (
            <button
              className="bg-transparent text-primary border-0"
              onClick={() => {
                setPrreviewType(attachment[0]?.name?.split(".")?.pop());
                handlePreviewClick(
                  record?.attachment[0]?.documentId,
                  "professionalcertifications",
                  attachment[0]?.name
                );
              }}
            >
              {attachment[0]?.name}
            </button>
          );
        } else {
          return "-";
        }
      },
    },
  ];

  const PracticalTrainingColumns = [
    {
      title: t("Organisation Name"),
      dataIndex: "organisationname",
      key: "organisationname",
      width: "5%",
    },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate, record) => {
        if (
          fromdate &&
          record?.organisationname &&
          moment(fromdate).isValid()
        ) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate, record) => {
        if (todate && record?.organisationname && moment(todate).isValid()) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Position Held"),
      dataIndex: "positionheld",
      key: "positionheld",
      align: "center",
      width: "5%",
    },
    {
      title: t("Nature of work & Tasks performed or completed"),
      dataIndex: "tasksperformed",
      key: "tasksperformed",
      width: "5%",
      className: "normal-column",
      render: (tasksperformed) => (
        <ViewMore value={tasksperformed} count={30} />
      ),
    },
  ];

  const wrokExperenceColumns = [
    { title: t("Company name"), dataIndex: "companyname", key: "companyname" },
    { title: t("Job Title"), dataIndex: "jobtitle", key: "jobtitle" },
    {
      title: t("From"),
      dataIndex: "fromdate",
      key: "fromdate",
      render: (fromdate, record) => {
        if (fromdate && record?.companyname) {
          return moment(fromdate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("To"),
      dataIndex: "todate",
      key: "todate",
      render: (todate, record) => {
        if (todate && record?.companyname) {
          return moment(todate).format("DD-MM-YYYY");
        } else {
          return "-";
        }
      },
    },
    {
      title: t("Job Description"),
      dataIndex: "jobdescription",
      key: "jobdescription",
      className: "normal-column",
      render: (jobdescription) => <ViewMore value={jobdescription} />,
    },
    {
      title: t("Relevant"),
      dataIndex: "relevnt",
      key: "relevnt",
      align: "center",
    },
  ];

  const getPolicyData = async () => {
    setLoading(true);
    const { response } = await CALL_API(`hrpolicy/${ClientId}`, "get", {});
    setLoading(false);
    setDataSource(response);
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const filterbyrole = dataSource?.filter((item) =>
    item?.roleId?.includes(userRoleId)
  );

  const filteredDataSource = filterbyrole?.filter((item) =>
    item.policyTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const policyColumns = [
    { title: t("Policy Name"), dataIndex: "policyTitle", key: "policyName" },
    { title: t("Type"), dataIndex: "policyType", key: "policyType" },
  ];

  const iconStyle = { fontSize: "18px", color: "#fff", paddingBottom: "3px" };

  const cursorstyle = {
    cursor: "pointer",
    position: "absolute",
    top: "20px",
  };

  const CropPopModal = () => {
    setShowImageModal(true);
  };

  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setSelectedImage(file);
  };

  const CloseImageModal = async () => {
    setShowImageModal(false);
    setZoomin(1);
    setRotatein(0);
  };
  const resetSelectedImage = () => {
    setSelectedImage(null);
  };

  return (
    <>
      {updateState === "" ? (
        <StyledProfileContainer>
          <Row className="profile-row" gutter={24}>
            <Col md={24} sm={24} xs={24} lg={24}>
              <StyledCard>
                <Row className="main_row">
                  <Col md={24} sm={24} xs={24} lg={4}>
                    <Badge
                      count={
                        Menulist?.find(
                          (item) =>
                            item?.key === "profile" &&
                            item?.subMenu?.find(
                              (subItem) =>
                                subItem?.key === "mydetails" &&
                                subItem?.permission.edit
                            )
                        ) && (
                          <Icon
                            style={cursorstyle}
                            name="profileEdit"
                            className="camera_select_icon"
                            onClick={CropPopModal}
                          />
                        )
                      }
                    >
                      <StyledStaffNameContainer>
                        {profilePic === null ||
                        profilePic === "" ||
                        Array.isArray(profilePic) ? (
                          <StyledAvatar size="default">
                            {startCase(get(userInfo, "name", "").charAt(0))}
                          </StyledAvatar>
                        ) : (
                          <StyledAvatar src={profilePic} size="default" />
                        )}
                      </StyledStaffNameContainer>
                    </Badge>
                  </Col>

                  <Col md={24} sm={24} xs={24} lg={10}>
                    <StyledRow className="my-4">
                      <Col className="my-1" xs={24} lg={8}>
                        <b>{t("Name")}</b>
                      </Col>
                      <Col className="my-1" xs={24} lg={10}>
                        {get(userInfo, "name", "")}
                      </Col>
                    </StyledRow>
                    <StyledRow className="my-4">
                      <Col className="my-1" xs={24} lg={8}>
                        <b>{t("Email ID")}</b>
                      </Col>
                      <Col className="my-1" xs={24} lg={10}>
                        {get(userInfo, "userid", "")}
                      </Col>
                    </StyledRow>
                  </Col>

                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    lg={10}
                    className="second_half_info"
                  >
                    <StyledRow className="my-4">
                      <Col className="my-1" xs={24} lg={8}>
                        <b>
                          {userRoleId === "1"
                            ? t("Client ID")
                            : t("Employee ID")}
                        </b>
                      </Col>
                      <Col className="my-1" xs={24} lg={10}>
                        {userRoleId === "1"
                          ? ClientId
                          : filteruser[0]?.employeeid}
                      </Col>
                    </StyledRow>
                    <StyledRow className="my-4">
                      <Col className="my-1" xs={24} lg={8}>
                        <b>{t("Joining Date")}</b>
                      </Col>
                      <Col className="my-1" xs={24} lg={10}>
                        {moment(userInfo?.joining_date).format("DD-MMMM-yyyy")}
                      </Col>
                    </StyledRow>
                  </Col>

                  <div className="right">
                    <Col>
                      <ResetPasswordLink
                        onClick={() => setOpenResetPasswordModal(true)}
                      >
                        {t("Change Password")}
                      </ResetPasswordLink>
                    </Col>
                    <Col>
                      <b>
                        <ResetPasswordLink onClick={() => logoutUser()}>
                          {t("Logout")}
                        </ResetPasswordLink>
                      </b>
                    </Col>
                  </div>
                </Row>
              </StyledCard>
            </Col>
          </Row>
          <StyledTab>
            <Tabs
              activeKey={activeTabId}
              onChange={handleTabSelect}
              items={items.map((val) => ({
                label: val.label,
                key: val.id,
                children: val.component,
              }))}
            />
          </StyledTab>
          {activeTab === "My Details" && (
            <>
              <div className="mb-2 d-flex justify-content-between align-items-center">
                <b>Personal Information</b>
                {Menulist?.find(
                  (item) =>
                    item?.key === "profile" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "mydetails" && subItem?.permission.edit
                    )
                ) && (
                  <ButtonFilled
                    className="px-1"
                    onClick={() => setUpdateState("personalinformation")}
                  >
                    <Icon name="profileEdit"></Icon>
                  </ButtonFilled>
                )}
              </div>
              <Row className="personal_details_box px-3">
                {personalDet.map((data, index) => {
                  return (
                    <Col xs={24} lg={12} key={index}>
                      <StyledRow className="p-0 m-0">
                        <Col sm={24} md={12} className="px-2 text-wrap">
                          <b className="pb-1 pt-2">{data.data}: </b>
                        </Col>
                        <Col sm={24} md={12} className="text-wrap px-2 p-0 m-0">
                          <p className="m-0 p-1 label_value_Color">
                            {data.value}
                          </p>
                        </Col>
                      </StyledRow>
                    </Col>
                  );
                })}
              </Row>
              <div className="my-2  d-flex justify-content-between align-items-center">
                <b className="mt-2">Work Information</b>
                {Menulist?.find(
                  (item) =>
                    item?.key === "profile" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "mydetails" && subItem?.permission.edit
                    )
                ) && (
                  <ButtonFilled
                    className="px-1"
                    onClick={() => setUpdateState("workinformation")}
                  >
                    {/* <Icon name="edit"></Icon> */}
                  </ButtonFilled>
                )}
              </div>
              <Row className="personal_details_box px-3">
                {WorkInfoDetails.map((data, index) => {
                  return (
                    <Col xs={24} lg={12} key={index}>
                      <StyledRow className="p-0 m-0">
                        <Col sm={24} md={12} className="px-2 text-wrap">
                          <b className="pb-1 pt-2">{data.data}: </b>
                        </Col>
                        <Col sm={24} md={12} className="text-wrap px-2 p-0 m-0">
                          <p className="m-0 p-1 label_value_Color">
                            {data.value}
                          </p>
                        </Col>
                      </StyledRow>
                    </Col>
                  );
                })}
              </Row>

              <div className="mb-2 d-flex justify-content-between align-items-center">
                <b className="mt-3">Education Details:</b>
                {Menulist?.find(
                  (item) =>
                    item?.key === "profile" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "mydetails" && subItem?.permission.edit
                    )
                ) && (
                  <ButtonFilled
                    className="px-1"
                    onClick={() => setUpdateState("educationdetails")}
                  ></ButtonFilled>
                )}
              </div>
              <StyledTable
                dataSource={filteruser[0]?.educationdetails}
                columns={EducationColumns}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "" : "non-white"
                }
                rowKey="role_id"
                pagination={false}
              />

              <div className="mb-2 d-flex justify-content-between align-items-center">
                <b className="mt-3">Professional Certification:</b>
                {Menulist?.find(
                  (item) =>
                    item?.key === "profile" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "mydetails" && subItem?.permission.edit
                    )
                ) && (
                  <ButtonFilled
                    className="px-1"
                    onClick={() => setUpdateState("professionalcertifications")}
                  ></ButtonFilled>
                )}
              </div>
              <StyledTable
                dataSource={filteruser[0]?.professionalcertifications}
                columns={PersenalcertificationColumns}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "" : "non-white"
                }
                rowKey="role_id"
                pagination={false}
              />

              <div className="mb-2 d-flex justify-content-between align-items-center">
                <b className="mt-3">Practical Training:</b>
                {Menulist?.find(
                  (item) =>
                    item?.key === "profile" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "mydetails" && subItem?.permission.edit
                    )
                ) && (
                  <ButtonFilled
                    className="px-1"
                    onClick={() => setUpdateState("practicaltrainings")}
                  >
                    {/* <Icon name="edit"></Icon> */}
                  </ButtonFilled>
                )}
              </div>
              <StyledTable
                dataSource={filteruser[0]?.practicaltrainings}
                columns={PracticalTrainingColumns}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "" : "non-white"
                }
                rowKey="role_id"
                pagination={false}
              />

              <div className="mb-2 d-flex justify-content-between align-items-center">
                <b className="mt-3">Work Experience:</b>
                {Menulist?.find(
                  (item) =>
                    item?.key === "profile" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "mydetails" && subItem?.permission.edit
                    )
                ) && (
                  <ButtonFilled
                    className="px-1"
                    onClick={() => setUpdateState("workexperience")}
                  >
                    {/* <Icon name="edit"></Icon> */}
                  </ButtonFilled>
                )}
              </div>
              <StyledTable
                className="mb-5"
                dataSource={filteruser[0]?.workexperience}
                columns={wrokExperenceColumns}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "" : "non-white"
                }
                rowKey="role_id"
                pagination={false}
              />
            </>
          )}
          {activeTab === "Report Preference" && (
            <>
              {Menulist.filter(
                (menu) =>
                  menu.access === true &&
                  menu.path === "profile" &&
                  menu.subMenu?.some(
                    (sub) =>
                      sub.access === true && sub?.key === "reportpreference"
                  )
              ).length > 0 && (
                <Col md={24} sm={24} xs={24} lg={24}>
                  <StyledCard1 bordered={false}>
                    <Spin spinning={displayReportLoader}>
                      <div className="main_div">
                        <Col className="mt-1 mb-2" lg={24}>
                          <b>{t("Report Preferences")}</b>
                        </Col>

                        {/* Attendance Report */}
                        <StyleRow gutter={16}>
                          <Col className="mb-1 sm-mb-4 row-gap" xs={12} lg={8}>
                            {t("Attendance Report")}
                          </Col>
                          <Col className="align-center row-gap" xs={12} lg={4}>
                            <Switch
                              size="small"
                              checked={attendanceReport}
                              disabled={
                                Menulist?.find(
                                  (item) =>
                                    item.access === true &&
                                    item.path === "profile" &&
                                    item.subMenu?.some(
                                      (sub) =>
                                        sub?.key === "reportpreference" &&
                                        sub?.permission?.create
                                    )
                                )
                                  ? false
                                  : true
                              }
                              onClick={() => {
                                handleChange(
                                  attendanceReportId,
                                  attendanceReport === true ? "false" : "true",
                                  attendanceReportTime.format("HH:mm")
                                );
                                setAttendanceReport(
                                  attendanceReport === true ? false : true
                                );
                              }}
                            />
                          </Col>
                          <Col className="mb-1" xs={12} lg={6}>
                            {t("Period : Daily")}
                          </Col>
                          <Col className="align-center" xs={12} lg={6}>
                            {attendanceReport ? (
                              <TimePicker
                                value={attendanceReportTime}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                onChange={(val) => {
                                  handleChange(
                                    attendanceReportId,
                                    attendanceReport === true
                                      ? "true"
                                      : "false",
                                    val.format("HH:mm")
                                  );
                                  setAttendanceReportTime(moment(val, "HH:mm"));
                                }}
                                clearIcon={null}
                              />
                            ) : (
                              <TimePicker
                                value={attendanceReportTime}
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                clearIcon={null}
                              />
                            )}
                          </Col>
                        </StyleRow>

                        {/* Overtime Report */}
                        <StyleRow gutter={16}>
                          <Col className="mb-1 row-gap" xs={12} lg={8}>
                            {t("Overtime Report")}
                          </Col>
                          <Col className="align-center row-gap" xs={12} lg={4}>
                            <Switch
                              size="small"
                              checked={overtimeReport}
                              disabled={
                                Menulist?.find(
                                  (item) =>
                                    item.access === true &&
                                    item.path === "profile" &&
                                    item.subMenu?.some(
                                      (sub) =>
                                        sub?.key === "reportpreference" &&
                                        sub?.permission?.create
                                    )
                                )
                                  ? false
                                  : true
                              }
                              onClick={() => {
                                handleChange(
                                  overtimeReportId,
                                  overtimeReport === true ? "false" : "true",
                                  overtimeReportTime.format("HH:mm")
                                );
                                setOvertimeReport(
                                  overtimeReport === true ? false : true
                                );
                              }}
                            />
                          </Col>
                          <Col className="mb-1" xs={12} lg={6}>
                            {t("Period : Daily")}
                          </Col>
                          <Col className="align-center" xs={12} lg={6}>
                            {overtimeReport ? (
                              <TimePicker
                                value={overtimeReportTime}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                onChange={(val) => {
                                  handleChange(
                                    overtimeReportId,
                                    overtimeReport === true ? "true" : "false",
                                    val.format("HH:mm")
                                  );
                                  setOvertimeReportTime(moment(val, "HH:mm"));
                                }}
                                clearIcon={null}
                              />
                            ) : (
                              <TimePicker
                                value={overtimeReportTime}
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                clearIcon={null}
                              />
                            )}
                          </Col>
                        </StyleRow>

                        {/* Exception Report Header */}
                        <StyleRow>
                          <Col xs={14} lg={12} className="sub_title">
                            {t("Exception Report")}
                          </Col>
                        </StyleRow>

                        {/* Late Check-in Report */}
                        <StyleRow gutter={16}>
                          <Col className="mb-1 row-gap" xs={12} lg={8}>
                            {t("Late Check-in Report")}
                          </Col>
                          <Col className="align-center row-gap" xs={12} lg={4}>
                            <Switch
                              size="small"
                              checked={lateCheckinReport}
                              disabled={
                                Menulist?.find(
                                  (item) =>
                                    item.access === true &&
                                    item.path === "profile" &&
                                    item.subMenu?.some(
                                      (sub) =>
                                        sub?.key === "reportpreference" &&
                                        sub?.permission?.create
                                    )
                                )
                                  ? false
                                  : true
                              }
                              onClick={() => {
                                handleChange(
                                  lateCheckinReportId,
                                  lateCheckinReport === true ? "false" : "true",
                                  lateCheckinReportTime.format("HH:mm")
                                );
                                setLateCheckinReport(
                                  lateCheckinReport === true ? false : true
                                );
                              }}
                            />
                          </Col>
                          <Col className="mb-1" xs={12} lg={6}>
                            {t("Period : Daily")}
                          </Col>
                          <Col className="align-center" xs={12} lg={6}>
                            {lateCheckinReportTime ? (
                              <TimePicker
                                value={lateCheckinReportTime}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                onChange={(val) => {
                                  handleChange(
                                    lateCheckinReportId,
                                    lateCheckinReport === true
                                      ? "true"
                                      : "false",
                                    val.format("HH:mm")
                                  );
                                  setLateCheckinReportTime(
                                    moment(val, "HH:mm")
                                  );
                                }}
                                clearIcon={null}
                              />
                            ) : (
                              <TimePicker
                                value={lateCheckinReportTime}
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                clearIcon={null}
                              />
                            )}
                          </Col>
                        </StyleRow>

                        {/* Early Check-out Report */}
                        <StyleRow gutter={16}>
                          <Col className="mb-1 row-gap" xs={12} lg={8}>
                            {t("Early Check-out Report")}
                          </Col>
                          <Col className="align-center" xs={12} lg={4}>
                            <Switch
                              size="small"
                              checked={earlyCheckoutReport}
                              disabled={
                                Menulist?.find(
                                  (item) =>
                                    item.access === true &&
                                    item.path === "profile" &&
                                    item.subMenu?.some(
                                      (sub) =>
                                        sub?.key === "reportpreference" &&
                                        sub?.permission?.create
                                    )
                                )
                                  ? false
                                  : true
                              }
                              onClick={() => {
                                handleChange(
                                  earlyCheckoutReportId,
                                  earlyCheckoutReport === true
                                    ? "false"
                                    : "true",
                                  earlyCheckoutReportTime.format("HH:mm")
                                );
                                setEarlyCheckoutReport(
                                  earlyCheckoutReport === true ? false : true
                                );
                              }}
                            />
                          </Col>
                          <Col className="mb-1 row-gap" xs={12} lg={6}>
                            {t("Period : Daily")}
                          </Col>
                          <Col className="align-center" xs={12} lg={6}>
                            {earlyCheckoutReportTime ? (
                              <TimePicker
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                value={earlyCheckoutReportTime}
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                onChange={(val) => {
                                  handleChange(
                                    earlyCheckoutReportId,
                                    earlyCheckoutReport === true
                                      ? "true"
                                      : "false",
                                    val.format("HH:mm")
                                  );
                                  setEarlyCheckoutReportTime(
                                    moment(val, "HH:mm")
                                  );
                                }}
                                clearIcon={null}
                              />
                            ) : (
                              <TimePicker
                                value={earlyCheckoutReportTime}
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                clearIcon={null}
                              />
                            )}
                          </Col>
                        </StyleRow>

                        {/* Absent Report */}
                        <StyleRow gutter={16}>
                          <Col className="mb-1 row-gap" xs={12} lg={8}>
                            {t("Absent Report")}
                          </Col>
                          <Col className="align-center row-gap" xs={12} lg={4}>
                            <Switch
                              size="small"
                              checked={absentReport}
                              disabled={
                                Menulist?.find(
                                  (item) =>
                                    item.access === true &&
                                    item.path === "profile" &&
                                    item.subMenu?.some(
                                      (sub) =>
                                        sub?.key === "reportpreference" &&
                                        sub?.permission?.create
                                    )
                                )
                                  ? false
                                  : true
                              }
                              onClick={() => {
                                handleChange(
                                  absentReportId,
                                  absentReport === true ? "false" : "true",
                                  absentReportTime.format("HH:mm")
                                );
                                setAbsentReport(
                                  absentReport === true ? false : true
                                );
                              }}
                            />
                          </Col>
                          <Col className="mb-1" xs={12} lg={6}>
                            {t("Period : Daily")}
                          </Col>
                          <Col className="align-center" xs={12} lg={6}>
                            {absentReportTime ? (
                              <TimePicker
                                value={absentReportTime}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                onChange={(val) => {
                                  handleChange(
                                    absentReportId,
                                    absentReport === true ? "true" : "false",
                                    val.format("HH:mm")
                                  );
                                  setAbsentReportTime(moment(val, "HH:mm"));
                                }}
                                clearIcon={null}
                              />
                            ) : (
                              <TimePicker
                                value={absentReportTime}
                                format={"HH:mm"}
                                disabled={
                                  Menulist?.find(
                                    (item) =>
                                      item.access === true &&
                                      item.path === "profile" &&
                                      item.subMenu?.some(
                                        (sub) =>
                                          sub?.key === "reportpreference" &&
                                          sub?.permission?.create
                                      )
                                  )
                                    ? false
                                    : true
                                }
                                clearIcon={null}
                              />
                            )}
                          </Col>
                        </StyleRow>
                      </div>
                    </Spin>
                  </StyledCard1>
                </Col>
              )}
            </>
          )}
        </StyledProfileContainer>
      ) : (
        <EditProfile
          updateState={updateState}
          setUpdateState={setUpdateState}
          EmployeeDetails={EmployeeDetails}
          pageName="Profile"
        />
      )}

      <StyledDocumentModal
        centered={true}
        visible={isPreviewModalOpen}
        footer={false}
        keyboard={false}
        width="100%"
        height="100vh"
        onOk={() => setIsPreviewModalOpen(false)}
        onCancel={() => setIsPreviewModalOpen(false)}
      >
        <Spin spinning={isLoadingDocuments}>
          {previewType === "jpg" ||
          previewType === "png" ||
          previewType === "jpeg" ||
          previewType === "svg" ? (
            <div className="img">
              <img src={previewURL} className="img_fit" alt={t("Preview")} />
            </div>
          ) : (
            <embed
              title={t("PDF Viewer")}
              src={previewURL}
              type="application/pdf"
              width="100%"
              height="600px"
              className="pdf-viewer-embed px-5"
            />
          )}
        </Spin>
      </StyledDocumentModal>

      <ChangePasswordModal
        openResetPasswordModal={openResetPasswordModal}
        toggleResetPasswordModal={() =>
          setOpenResetPasswordModal(!openResetPasswordModal)
        }
      />
      <StyledModal
        title={t("Profile Picture")}
        open={showImageModal}
        onCancel={() => {
          CloseImageModal();
          resetSelectedImage();
        }}
        confirmLoading={confirmLoading}
        footer={[
          <ButtonOutlined
            key="cancel"
            onClick={() => {
              CloseImageModal();
              resetSelectedImage();
            }}
          >
            {t("Cancel")}
          </ButtonOutlined>,
          <ButtonFilled
            key="save"
            onClick={() => {
              handleUploadProfile();
            }}
            loading={confirmLoading}
          >
            {t("Set")}
          </ButtonFilled>,
        ]}
      >
        {selectedImage ? (
          <div>
            <AvatarEditor
              ref={editorRef}
              image={objectUrl}
              width={200}
              height={200}
              border={50}
              color={[255, 255, 255, 0.6]}
              scale={zoomin}
              rotate={rotatein}
              borderRadius={250}
            />
            <div className="editor_div">
              <label>{t("Zoom")}:</label>
              <Slider
                defaultValue={zoomin}
                onChange={setZoomin}
                min={1}
                max={20}
              />
            </div>
            <div className="editor_div">
              <label>{t("Rotate")}:</label>
              <Slider
                defaultValue={rotatein}
                onChange={setRotatein}
                min={0}
                max={360}
              />
            </div>
            <MainStyledDropzone onDrop={handleDrop} />
          </div>
        ) : (
          <MainStyledDropzone onDrop={handleDrop} />
        )}
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  notificationList: getNotificationList(state),
  userRoleId: getUserRoleId(state),
  profilePic: getProfilePic(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  userList: getUserList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveProfilePic: setProfilePic,
      removeStoreData: clearStore,
      setUserLoggedIn: setIsUserLoggedIn,
      updateUserList: setUserList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
